<template>
    <div class="parametrizacao">
        <div class="page">
            <div class="listing-header mb-3">
                <div class="title-breadcrumb"><h1 class="title">{{ $t('parametrizacoes-campos') }}</h1></div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="onFecharModal"
                    >
                        {{ $t("voltar") }}
                    </button>
                </div>
            </div>
            <div class="campos">
                <v-draggable
                    :list="fields"
                >
                    <div 
                        v-for="field in fields"
                        :key="field.key"
                    >
                        <div v-show="field.key !== 'situacao'" class="page-container form-columns-fit">
                            <div class="columns">
                                <span
                                    v-tippy 
                                    :title="$t('msg-campo-ordencao')"
                                >
                                    <svg class="svg-icons">
                                        <use :xlink:href="require('@/assets/img/icons/drag.svg')+'#layer'"></use>
                                    </svg>
                                </span>
                                <div class="container">
                                    <b-checkbox v-model="field.visible"></b-checkbox>
                                    {{ $t(field.label) }} 
                                </div>
                            </div>
                        </div>
                    </div>
                </v-draggable>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fields: {
            type: Array,
            default: []
        }
    },
    data() {
        return {}
    },
    methods: {
        onFecharModal(){
            this.$emit('fecharModal', true);
        },
    },
}
</script>


<style lang="scss" scoped>
.parametrizacao {
    padding: 20px 20px;

    .page {
        .isEmpty {
            position: relative;
            display: flex;
            flex-flow: column;
            height: 100%;
        }

        .campos {
            height: auto;
            width: 100%;
            padding-top: 10px;
            .page-container {
                margin-bottom: 10px;
                padding-bottom: 10px;
                border: solid 2px #FFFF;

                &:hover, &:focus{
                    border: 2px solid $primary-color-hover; 
                }
            }
            .gp-handle {
                display: flex;
                align-items: center;
                margin-right: 10px;
                
                svg {
                    transform: rotate(90deg);
                }
            }
            .container {
                display: flex;
                align-items: center;
            }
        }
    }
}
</style>